export default __webpack_public_path__ + "static/logo-mpk-15253fee5539ad0f17d076dca8bf5312.png";